import { Component } from "react";
import { FstyrDropdown } from "./FstyrDropdown";
import { FstyrSegment } from "./FstyrSegment";
import { FstyrInput } from "./FstyrInput";
import { FstyrInputCpr } from "./FstyrInputCpr";
import { FstyrSelectableTable } from "./FstyrSelectableTable";
import { FstyrTable } from "./FstyrTable";
import { FstyrRadioButtonGroup } from "./FstyrRadioButtonGroup";
import { FstyrCheckbox } from "./FstyrCheckbox";
import { FstyrButton } from "./FstyrButton";
import { FstyrDatePicker } from "./FstyrDatePicker";
import { FstyrModal } from "./FstyrModal";
import { FstyrNoteModal } from "./FstyrNoteModal";
import { FstyrBetjentModal } from "./FstyrBetjentModal";
import { FstyrAlertInfo } from "./FstyrAlertInfo.js";
import { FstyrToast } from "./FstyrToast";
import { FstyrDropdownSearch } from "./FstyrDropdownSearch";
import { FstyrSpinner } from "./FstyrSpinner";

const Dropdown = FstyrDropdown;
const Segment = FstyrSegment;
const Input = FstyrInput;
const InputCpr = FstyrInputCpr;
const SelectableTable = FstyrSelectableTable;
const Table = FstyrTable;
const RadioButtonGroup = FstyrRadioButtonGroup;
const Checkbox = FstyrCheckbox;
const Button = FstyrButton;
const DatePicker = FstyrDatePicker;
const Modal = FstyrModal;
const NoteModal = FstyrNoteModal;
const BetjentModal = FstyrBetjentModal;
const AlertInfo = FstyrAlertInfo;
const Toast = FstyrToast;
const DropdownSearch = FstyrDropdownSearch;
const Spinner = FstyrSpinner;

export class Fstyr extends Component {}

Fstyr.Dropdown = Dropdown;
Fstyr.Segment = Segment;
Fstyr.Input = Input;
Fstyr.InputCpr = InputCpr;
Fstyr.SelectableTable = SelectableTable;
Fstyr.Table = Table;
Fstyr.RadioButtonGroup = RadioButtonGroup;
Fstyr.Checkbox = Checkbox;
Fstyr.Button = Button;
Fstyr.DatePicker = DatePicker;
Fstyr.Modal = Modal;
Fstyr.NoteModal = NoteModal;
Fstyr.BetjentModal = BetjentModal;
Fstyr.AlertInfo = AlertInfo;
Fstyr.Toast = Toast;
Fstyr.DropdownSearch = DropdownSearch;
Fstyr.Spinner = Spinner;
